/**
 * #52 (DEC-358) — a link from web-dispatch into web-billing, which is a separate app on its own
 * origin: billing.<env>.lodexpro.com beside dispatch.<env>.lodexpro.com, and port 5174 beside
 * 5173 in local dev (both vite.config.ts). VITE_BILLING_APP_URL overrides the derivation.
 */

/** The customer disposal fee page, opened on one customer with the fee form for one place. */
export function disposalFeeUrl(
  target: {
    readonly haulerOperatorId: string | null;
    readonly site: { readonly kind: 'FACILITY' | 'LOCATION' | 'WELL'; readonly id: string };
  },
  origin: string = billingAppOrigin(),
): string {
  const params = new URLSearchParams({ kind: target.site.kind, placeId: target.site.id });
  if (target.haulerOperatorId !== null) {
    params.set('tab', 'customer');
    params.set('customerId', target.haulerOperatorId);
  }
  return `${origin}/disposal-fees?${params.toString()}`;
}

/** gap 1 (DEC-383, D-10): the web-billing customer page, where job-type prices are edited. */
export function customerPricesUrl(
  haulerOperatorId: string,
  origin: string = billingAppOrigin(),
): string {
  return `${origin}/customers/${encodeURIComponent(haulerOperatorId)}`;
}

export function billingAppOrigin(
  location: Pick<Location, 'protocol' | 'hostname' | 'port'> = window.location,
  override: string | undefined = import.meta.env.VITE_BILLING_APP_URL as string | undefined,
): string {
  if (override !== undefined && override !== '') return override.replace(/\/+$/, '');
  const { protocol, hostname, port } = location;
  if (hostname.startsWith('dispatch.')) {
    return `${protocol}//billing.${hostname.slice('dispatch.'.length)}${port === '' ? '' : `:${port}`}`;
  }
  // Local dev: the same host, web-billing's port.
  return `${protocol}//${hostname}:5174`;
}
